import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SkuflixPipIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M20.2564 11.6235V5.17908C20.2564 4.57007 20.0631 3.98601 19.7191 3.55537C19.375 3.12474 18.9083 2.88281 18.4217 2.88281H4.66094C4.17433 2.88281 3.70765 3.12474 3.36356 3.55537C3.01948 3.98601 2.82617 4.57007 2.82617 5.17908V16.6604C2.82617 17.9234 3.65182 18.9567 4.66094 18.9567H8.33047"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M19.3391 14.75H13.8348C12.8215 14.75 12 15.5822 12 16.6088V19.3969C12 20.4235 12.8215 21.2557 13.8348 21.2557H19.3391C20.3524 21.2557 21.1738 20.4235 21.1738 19.3969V16.6088C21.1738 15.5822 20.3524 14.75 19.3391 14.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
